<template>
  <div class="optionDesc" :class="{ '-show': step.moreInfo }">
    ##More information##
  </div>
  <div class="m-priceCalculator__sizeStep" v-if="sizes.length > 0">
    <div class="m-sizeRow">
      <div class="m-sizeLabel">&nbsp;</div>
      <div :key="'w' + windex"
           v-for="(w, windex) in step.SizeMap.Item1"
           :style="{ 'flex-basis': (w.Item1 / totalWidth) * 100 + '%' }">
        {{ (w.Item1 / 10).toFixed() }} <br />cm
      </div>
    </div>

    <div class="m-sizeRow"
         :key="'h' + hindex"
         v-for="(h, hindex) in step.SizeMap.Item2">
      <div class="m-sizeLabel">{{ h.Label }}<br />cm</div>

      <div class="m-sizeCell"
           v-for="(w, sindex) in step.SizeMap.Item1"
           :key="'s' + sindex"
           :style="{ 'flex-basis': (w.Item1 / totalWidth) * 100 + '%' }"
           :class="{
          '-hasOption':sizes && sizes[w.Item1] && sizes[w.Item1][h.Item1],
          '-unavailable':
            sizes &&
            sizes[w.Item1] &&
            sizes[w.Item1][h.Item1] &&
            !sizes[w.Item1][h.Item1].isValid,
        }">
        <div class="sizeWindow"
             :style="{ 'padding-top': (h.Item1 / w.Item1) * 100 + '%' }"
             :class="{
            '-selected':
              sizes &&
            sizes[w.Item1] &&
              sizes[w.Item1][h.Item1] &&
              step.selectedOption &&
              step.selectedOption.Id == sizes[w.Item1][h.Item1].Id,
          }">
          <div v-if="sizes[w.Item1] && sizes[w.Item1][h.Item1]"
               @click="selectOption(step, sizes[w.Item1][h.Item1])">
            <span class="desc">
              {{ w.Label }} x {{ h.Label }} <br />
              {{ sizes[w.Item1][h.Item1] ? sizes[w.Item1][h.Item1].Title : "" }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sizeLegend">
    <p>
      {{ content.labels["LegendHeader"] }}
    </p>
    <ul>
      <li>
        <div class="sizeColor -available"></div>
        {{ content.labels["SizeAvailableColor"] }}
      </li>
      <li>
        <div class="sizeColor -selected"></div>
        {{ content.labels["SizeSelectedColor"] }}
      </li>
      <li>
        <div class="sizeColor -unavailable"></div>
        {{ content.labels["SizeNotAvailableColor"] }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "SizeStep",
    props: ["content"],
    emits: ["select-option"],
    data() {
      const sizes = [];
      let totalWidth = 0;

      this.step = this.content.step;

      this.step.Options.forEach((o) => {
        this.step.SizeMap.Item1.forEach((w) => {
          if (typeof w.Label === "undefined") {
            w.Label = (w.Item1 / 10).toFixed();
            totalWidth += w.Item1;
          }
          this.step.SizeMap.Item2.forEach((h) => {
            if (!h.Label) {
              h.Label = (h.Item1 / 10).toFixed();
            }

            if (o.Lookup.startsWith(w.Item2) && o.Lookup.endsWith(h.Item2)) {
              if (!sizes[w.Item1]) {
                sizes[w.Item1] = [];
              }

              sizes[w.Item1][h.Item1] = o;
              sizes[o.Lookup] = o;
            }
          });
        });
      });
      return {
        sizes,
        totalWidth,
      };
    },
    props: {
      content: Object,
    },
    methods: {
      selectOption(step, option, force) {
        if ((option && option.isValid) || force) {
          this.$emit("select-option", step, option);
        }
      },
    },
    mounted() {
      let defaultOption = this.step.Options.find((opt) => {
        return opt.Id === this.step.DefaultOption;
      });

      this.selectOption(this.step, defaultOption, true);
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../style/_vars";

  .m-priceCalculator__sizeStep {
    margin-bottom: 2rem;
    width: 100%;
  }

  .m-sizeRow {
    display: flex;
    align-items: center;

    &:first-child {
      text-align: center;
      font-weight: bold;
      font-size: 0.8em;
      padding-bottom: 0.5rem;
    }
  }

  .m-sizeCell {
    position: relative;
    outline: 1px solid lightgrey;

    &.-hasOption {
      background: gray;

      &:hover {
        background: $colorLightBlue;
      }

      .-selected {
        > div {
          box-shadow: 0px 0px 4px 4px rgba(0, 0, 0, 0.2);
          background: $colorLightBlue;
          z-index: 1;
          transform: scale(1.3);
          outline: 0.1rem solid white;
        }
      }
    }

    &.-unavailable {
      background: lightgray;
    }
  }

  .m-sizeLabel {
    flex-basis: 50px;

    &:first-child {
      text-align: center;
      font-weight: bold;
      font-size: 0.8em;
    }
  }

  .sizeWindow {
    > div {
      text-align: center;
      position: absolute;
      top: 1px;
      left: 1px;
      right: 1px;
      bottom: 1px;
      cursor: pointer;
      transition: 0.3s transform;
      border: 1px solid #fff;
    }

    .desc {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      color: white;
      font-size: 0.6rem;
      font-weight: bold;
      text-align: center;
    }
  }

  .sizeLegend {
    width: 100%;

    p {
      background: lightgray;
      line-height: 3em;
      padding-left: 1em;
      padding-bottom: 0;
      margin-bottom: 1rem;
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        line-height: 2em;
        margin-bottom: 0.5em;
        padding-bottom: 0.5rem;
        padding-left: 1em;
        border-bottom: 2px solid lightgray;
      }
    }
  }

  .sizeColor {
    width: 2em;
    height: 2em;
    display: inline-block;
    vertical-align: middle;

    &.-available {
      background: gray;
    }

    &.-selected {
      background: $colorLightBlue;
    }

    &.-unavailable {
      background: lightgray;
    }
  }
</style>
